export default __webpack_public_path__ + "static/media/janani.2625b9d7.pdf";